/* eslint-disable camelcase */
import { mapState } from 'vuex';

export default {
  data() {
    return {
      idConfigNativeBtn: 'configNativeBtn',
      isOpenConfigNativeBtn: false,
      selectedNativeBtn: null,
      nativeButtons: {
        approve: null,
        create: null,
        delete: null,
        reject: null,
        update: null,
        draft: null,
        submit: null,
        close: null,
        cancel: null,
        revision: null,
        approveUpdate: null,
      },
      modeBtn: '',
      labelBtn: '',
    };
  },

  watch: {
    showModalScriptBeforeAfter(val) {
      if (val) {
        this.$refs.modalScriptBeforeAfter.show();
      } else {
        this.$refs.modalScriptBeforeAfter.hide();
      }
    },
  },

  computed: {
    ...mapState('jStoreExperienceManagerV2', ['showModalScriptBeforeAfter']),

    isDynamicWorkflow() {
      return this.form_data_detail.length > 0 ?
        (!!(this.form_data_detail[0].workflow && this.form_data_detail[0].workflow.type === 'dynamic')) : false;
    },

    isRevisionBtn() {
      return this.modeBtn === 'revision';
    },
  },

  created() {
    if (this.formDetail.native_buttons) {
      const data = JSON.parse(JSON.stringify(this.formDetail.native_buttons));
      const {
        approve, create, delete: deleted, reject, update, submit, close,
        cancel, draft, need_revision, approve_update,
      } = data;

      this.nativeButtons.approve = approve;
      this.nativeButtons.create = create;
      this.nativeButtons.delete = deleted;
      this.nativeButtons.reject = reject;
      this.nativeButtons.update = update;
      this.nativeButtons.submit = submit;
      this.nativeButtons.close = close;
      this.nativeButtons.cancel = cancel;
      this.nativeButtons.draft = draft;
      this.nativeButtons.revision = need_revision;
      this.nativeButtons.approveUpdate = approve_update || {
        label: '',
        script: '',
        script_before: '',
        container_script_before_is_not_valid: '',
        container_script_before_is_not_valid_message: '',
        variable_message: '',
        variable_redirect: '',
        container_params: '',
        container_record: '',
        type: null,
        is_hidden: true,
        revision_method: null,
        is_use_confirmation_message: false,
        custom_confirmation_message: '',
        dynamic_confirmation_message: '',
        dynamic_confirmation_message_params: null,
      };
    } else {
      this.nativeButtons.approve = {
        label: '',
        script: '',
        script_before: '',
        container_script_before_is_not_valid: '',
        container_script_before_is_not_valid_message: '',
        variable_message: '',
        variable_redirect: '',
        container_params: '',
        container_record: '',
        type: null,
        is_hidden: false,
        revision_method: null,
        is_use_confirmation_message: false,
        custom_confirmation_message: '',
        dynamic_confirmation_message: '',
        dynamic_confirmation_message_params: null,
      };

      this.nativeButtons.create = {
        label: '',
        script: '',
        script_before: '',
        container_script_before_is_not_valid: '',
        container_script_before_is_not_valid_message: '',
        variable_message: '',
        variable_redirect: '',
        container_params: '',
        container_record: '',
        type: null,
        is_hidden: false,
        revision_method: null,
        is_use_confirmation_message: false,
        custom_confirmation_message: '',
        dynamic_confirmation_message: '',
        dynamic_confirmation_message_params: null,
      };

      this.nativeButtons.delete = {
        label: '',
        script: '',
        script_before: '',
        container_script_before_is_not_valid: '',
        container_script_before_is_not_valid_message: '',
        variable_message: '',
        variable_redirect: '',
        container_params: '',
        container_record: '',
        type: null,
        is_hidden: false,
        revision_method: null,
        is_use_confirmation_message: false,
        custom_confirmation_message: '',
        dynamic_confirmation_message: '',
        dynamic_confirmation_message_params: null,
      };

      this.nativeButtons.reject = {
        label: '',
        script: '',
        script_before: '',
        container_script_before_is_not_valid: '',
        container_script_before_is_not_valid_message: '',
        variable_message: '',
        variable_redirect: '',
        container_params: '',
        container_record: '',
        type: null,
        is_hidden: false,
        revision_method: null,
        is_use_confirmation_message: false,
        custom_confirmation_message: '',
        dynamic_confirmation_message: '',
        dynamic_confirmation_message_params: null,
      };

      this.nativeButtons.update = {
        label: '',
        script: '',
        script_before: '',
        container_script_before_is_not_valid: '',
        container_script_before_is_not_valid_message: '',
        variable_message: '',
        variable_redirect: '',
        container_params: '',
        container_record: '',
        type: null,
        is_hidden: false,
        revision_method: null,
        is_use_confirmation_message: false,
        custom_confirmation_message: '',
        dynamic_confirmation_message: '',
        dynamic_confirmation_message_params: null,
      };

      this.nativeButtons.submit = {
        label: '',
        script: '',
        script_before: '',
        container_script_before_is_not_valid: '',
        container_script_before_is_not_valid_message: '',
        variable_message: '',
        variable_redirect: '',
        container_params: '',
        container_record: '',
        type: null,
        is_hidden: false,
        revision_method: null,
        is_use_confirmation_message: false,
        custom_confirmation_message: '',
        dynamic_confirmation_message: '',
        dynamic_confirmation_message_params: null,
      };

      this.nativeButtons.close = {
        label: '',
        script: '',
        script_before: '',
        container_script_before_is_not_valid: '',
        container_script_before_is_not_valid_message: '',
        variable_message: '',
        variable_redirect: '',
        container_params: '',
        container_record: '',
        type: null,
        is_hidden: false,
        revision_method: null,
        is_use_confirmation_message: false,
        custom_confirmation_message: '',
        dynamic_confirmation_message: '',
        dynamic_confirmation_message_params: null,
      };

      this.nativeButtons.cancel = {
        label: '',
        script: '',
        script_before: '',
        container_script_before_is_not_valid: '',
        container_script_before_is_not_valid_message: '',
        variable_message: '',
        variable_redirect: '',
        container_params: '',
        container_record: '',
        type: null,
        is_hidden: false,
        revision_method: null,
        is_use_confirmation_message: false,
        custom_confirmation_message: '',
        dynamic_confirmation_message: '',
        dynamic_confirmation_message_params: null,
      };

      this.nativeButtons.draft = {
        label: '',
        script: '',
        script_before: '',
        container_script_before_is_not_valid: '',
        container_script_before_is_not_valid_message: '',
        variable_message: '',
        variable_redirect: '',
        container_params: '',
        container_record: '',
        type: null,
        is_hidden: false,
        revision_method: null,
        is_use_confirmation_message: false,
        custom_confirmation_message: '',
        dynamic_confirmation_message: '',
        dynamic_confirmation_message_params: null,
      };

      this.nativeButtons.revision = {
        label: '',
        script: '',
        script_before: '',
        container_script_before_is_not_valid: '',
        container_script_before_is_not_valid_message: '',
        variable_message: '',
        variable_redirect: '',
        container_params: '',
        container_record: '',
        type: null,
        is_hidden: false,
        revision_method: null,
        is_use_confirmation_message: false,
        custom_confirmation_message: '',
        dynamic_confirmation_message: '',
        dynamic_confirmation_message_params: null,
      };

      this.nativeButtons.approveUpdate = {
        label: '',
        script: '',
        script_before: '',
        container_script_before_is_not_valid: '',
        container_script_before_is_not_valid_message: '',
        variable_message: '',
        variable_redirect: '',
        container_params: '',
        container_record: '',
        type: null,
        is_hidden: true,
        revision_method: null,
        is_use_confirmation_message: false,
        custom_confirmation_message: '',
        dynamic_confirmation_message: '',
        dynamic_confirmation_message_params: null,
      };
    }
  },

  methods: {
    openConfigNativeButton(mode, label) {
      if (this.modeBtn) {
        this.toggleConfigurationNativeBtn(false);

        setTimeout(() => {
          this.modeBtn = mode;
          this.labelBtn = label;
          this.selectedNativeBtn = this.nativeButtons[mode];
          this.toggleConfigurationNativeBtn(true);
        }, 250);
      } else {
        this.modeBtn = mode;
        this.labelBtn = label;
        this.selectedNativeBtn = this.nativeButtons[mode];
        this.toggleConfigurationNativeBtn(true);
      }
    },

    toggleConfigurationNativeBtn(status) {
      if (status) {
        this.isOpenConfigNativeBtn = true;

        setTimeout(() => {
          const element = document.getElementById(this.idConfigNativeBtn);
          if (element) element.classList.add('show-properties-field');
        }, 200);
      } else {
        const element = document.getElementById(this.idConfigNativeBtn);
        if (element) element.classList.remove('show-properties-field');

        setTimeout(() => {
          this.isOpenConfigNativeBtn = false;
          this.modeBtn = '';
          this.labelBtn = '';
          this.selectedNativeBtn = null;
        }, 200);
      }
    },

    submitNativeButton(params) {
      this.nativeButtons[this.modeBtn] = params;
      this.toggleConfigurationNativeBtn(false);
      this.setChangesValueView(true);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/form-ui-v2/jMixSetupNativeButton.js